import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTrophy = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 10,
	height: 10,
	viewBox: "0 0 10 10",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		id: "Frame",
		clipPath: "url(#clip0_725_1146)",
		children: /* @__PURE__ */ _jsx("path", {
			id: "Vector",
			d: "M6.87516 7.8125H3.12516M6.87516 7.8125C7.20668 7.8125 7.52462 7.9442 7.75904 8.17862C7.99346 8.41304 8.12516 8.73098 8.12516 9.0625H1.87516C1.87516 8.73098 2.00685 8.41304 2.24127 8.17862C2.47569 7.9442 2.79364 7.8125 3.12516 7.8125M6.87516 7.8125V6.40625C6.87516 6.1475 6.66557 5.9375 6.40641 5.9375H6.04349M3.12516 7.8125V6.40625C3.12516 6.1475 3.33516 5.9375 3.59391 5.9375H3.95724M6.04349 5.9375H3.95724M6.04349 5.9375C5.80946 5.53331 5.6696 5.08155 5.63432 4.61583M3.95724 5.9375C4.19112 5.53328 4.33084 5.08152 4.36599 4.61583M5.63432 4.61583C6.0543 4.51891 6.44585 4.32642 6.77932 4.05333M5.63432 4.61583C5.21702 4.71208 4.78329 4.71208 4.36599 4.61583M4.36599 4.61583C3.94615 4.51885 3.55434 4.32636 3.22099 4.05333M2.18766 1.765C1.77849 1.82458 1.37349 1.89708 0.972656 1.98167C1.06557 2.527 1.33665 3.02614 1.74347 3.40099C2.15029 3.77584 2.6699 4.00526 3.22099 4.05333M2.18766 1.765V1.875C2.18766 2.75333 2.59016 3.5375 3.22099 4.05333M2.18766 1.765V1.13375C3.10682 1.00417 4.04599 0.9375 5.00016 0.9375C5.95474 0.9375 6.89391 1.00417 7.81266 1.13333V1.765M7.81266 1.765V1.875C7.81266 2.75333 7.41016 3.5375 6.77932 4.05333M7.81266 1.765C8.21986 1.82425 8.62507 1.89651 9.02766 1.98167C8.93476 2.52693 8.66375 3.02602 8.25701 3.40087C7.85027 3.77572 7.33034 4.00517 6.77932 4.05333",
			stroke: "#89878C",
			strokeWidth: .7,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_725_1146",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 10,
			height: 10,
			fill: "white"
		})
	}) })]
});
export default SvgTrophy;
